<template>
	<div class="closeButton"><a href="#" v-on:click="click"><i class="fas fa-times"></i></a></div>
</template>

<script>
export default {
	methods: {
		click() {
			this.$emit('click')
		},
	},
}
</script>

<style scoped>

</style>